import { createDateRangeFilterConfig } from '../factories/create-date-range-filter-config';
import { buildDateRangeFacetKey } from '../helpers/build-date-range-facet-key';
import { FILTER_COLOR } from './filter-colors';

export const createdAtFilterConfig = createDateRangeFilterConfig({
  facetName: buildDateRangeFacetKey({
    before: 'created_at_before',
    after: 'created_at_after',
  }),
  color: FILTER_COLOR.yellow,
});
